import { render, staticRenderFns } from "./Tmplt.browser.vue?vue&type=template&id=6ca07647&"
import script from "./Tmplt.browser.vue?vue&type=script&lang=ts&"
export * from "./Tmplt.browser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports